var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"value":_vm.localValue,"disabled":_vm.disabledFlag,"placeholder":"请选择学期","clearable":""},on:{"input":function($event){_vm.$emit('input', $event)}}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.leamTermName,"value":item.id}})}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e01296ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/commonplugin/chose_param/chooseTerm.vue
// module id = null
// module chunks = 